import { ActionReducerMap } from '@ngrx/store'
import { HeliosFeatureState } from '../root.model'
import {
  commentaryActivityFeatureKey,
  commentaryActivityReducer,
} from './commentary-activity/commentary-activity.reducer'
import {
  commentaryCountsFeatureKey,
  commentaryCountsReducer,
} from './commentary-counts/commentary-counts.reducer'
import filterGroupReducer, { filterGroupsFeatureKey } from './filter-group'
import metricsReducer, { metricsFeatureKey } from './metrics'
import sessionReducer, { sessionFeatureKey } from './session'
import sessionCacheReducer, { sessionCacheFeatureKey } from './session-cache'
import userReducer, { userFeatureKey } from './user'
import workspaceReducer, { workspaceFeatureKey } from './workspace'

export const reducers: ActionReducerMap<HeliosFeatureState> = {
  [sessionFeatureKey]: sessionReducer,
  [sessionCacheFeatureKey]: sessionCacheReducer,
  [userFeatureKey]: userReducer,
  [workspaceFeatureKey]: workspaceReducer,
  [metricsFeatureKey]: metricsReducer,
  [filterGroupsFeatureKey]: filterGroupReducer,
  [commentaryCountsFeatureKey]: commentaryCountsReducer,
  [commentaryActivityFeatureKey]: commentaryActivityReducer,
}

export * from '../panels/external-transaction'
export * from './actions'
export * from './commentary.actions'
export * from './commentary-activity'
export * from './commentary-counts'
export * from './filter-group'
export * from './metrics'
export * from './session'
export * from './session-cache'
export * from './user'
export * from './workspace'
